// delLists/approvedLists/state.js

export const approvedInitialState = {
  items: [],
  tableType: "approved",
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
  needsUpdate: false,
  selectedApproved: null,
  selectedApprovedIds: [],
};
